module.exports = __webpack_public_path__ + "static/img/logo3.03d4d068.png";